/** Effective delay in seconds for a button, using the block delay as a floor. */
export const getEffectiveButtonDelaySeconds = (
  buttonDelay: number | null | undefined,
  blockDelay = 0
) => Math.max(blockDelay, buttonDelay ?? 0);

export const getButtonDelaysMs = (
  buttons: ReadonlyArray<{ delay?: number | null }>,
  blockDelay = 0
) => buttons.map((button) => getEffectiveButtonDelaySeconds(button.delay, blockDelay) * 1000);

export const getMinButtonDelayMs = (
  buttons: ReadonlyArray<{ delay?: number | null }>,
  blockDelay = 0
) => {
  if (buttons.length === 0) return 0;
  return Math.min(...getButtonDelaysMs(buttons, blockDelay));
};
